import { useCallback } from 'react';

import { PlanByPlanYear } from '@/modules/HealthPlan/HealthPlan.types';

import { AccountFundingConfigPaylod } from '../CoverageLevels.constants';

/**
 * Maps plans from PlanYear query to accountFundingConfigs format,
 * preserving existing config values (autoEnrollmentAmount, perPersonSpendLimit).
 */
const useMapAccountFundingConfigs = () => {
  const mapPlansToConfigs = useCallback(
    (
      plans: PlanByPlanYear[] | undefined,
      existingConfigs: AccountFundingConfigPaylod[] | undefined
    ): AccountFundingConfigPaylod[] | undefined => {
      if (!plans) return undefined;

      return plans.map((plan) => {
        const existingConfig = existingConfigs?.find((config) => config.planId === plan.id);

        return {
          id: `${existingConfig?.id || ''}`,
          planId: `${plan.id || ''}`,
          planName: plan.name,
          minElectionAmount: plan.minElectionAmount,
          maxElectionAmount: plan.maxElectionAmount,
          canSetHealthPlanSpendLimits: plan.canSetHealthPlanSpendLimits,
          autoEnrollmentAmount: `${existingConfig?.autoEnrollmentAmount || ''}`,
          perPersonSpendLimit: `${existingConfig?.perPersonSpendLimit || ''}`,
        };
      });
    },
    []
  );

  return { mapPlansToConfigs };
};

export default useMapAccountFundingConfigs;
